export const clinicFeaturesSlice = (set, get) => ({
    clinicFeatures: null,
    clinicFeaturesLoaded: false,
    clinicFeaturesLoading: false,

    setClinicFeatures: (features) =>
        set({
            clinicFeatures: features,
            clinicFeaturesLoaded: true,
            clinicFeaturesLoading: false,
        }),

    setClinicFeaturesLoading: (loading) =>
        set({ clinicFeaturesLoading: loading }),

    clearClinicFeatures: () =>
        set({
            clinicFeatures: null,
            clinicFeaturesLoaded: false,
            clinicFeaturesLoading: false,
        }),

    hasClinicFeature: (featureKey) => get().clinicFeatures?.[featureKey] === true,
});
